
import { mapGetters } from 'vuex';

import { parser, Schedules } from '@sopheos/orbjs_openinghour';
import { getDisplayPlaceName, getPlaceNameWithPreposition } from '../libraries/utils';

// Models
import Location from '../models/location';
// Assets
import facilitiesLang from '../assets/lang/facilities.json';

export default {
  name: 'SListItem',
  components: {
    SImageLoader: () => import('./SImageLoader.vue'),
  },
  props: {
    playground: {
      type: Object,
      required: true,
    },
    noDistance: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newPlayground: null,
      playgroundPhoto: null,
      todaySchedules: {},
      distance: null,
      facilities: facilitiesLang.playground,
      presentsFacilities: [],
    };
  },
  computed: {
    ...mapGetters({
      getCurrentSearch: 'transferData/getCurrentSearch',
      getCurrentDate: 'transferData/getCurrentDate',
    }),
    isValideDistance() {
      return typeof this.distance === 'number' && !Number.isNaN(this.distance);
    },
    cityName() {
      return getDisplayPlaceName(this.playground.city, this.playground.sub);
    },
    placeNameWithPreposition() {
      return getPlaceNameWithPreposition(this.cityName);
    },
  },
  watch: {
    playground: {
      immediate: true,
      handler() {
        this.buildPlayground();
      },
    },
  },
  mounted() {
    this.$emit('mounted');
  },
  methods: {
    buildPlayground() {
      // Check if it is a newly added playground
      const currentDate = new Date(this.getCurrentDate);
      const playDate = new Date(this.playground.created_at);
      playDate.setMonth(playDate.getMonth() + 1);
      this.newPlayground = currentDate < playDate;

      // Calculate the distance to the desired location, if necessary
      if (!this.noDistance) {
        const currentSearch = this.getCurrentSearch;
        if (currentSearch) {
          const playgroundLoc = new Location(this.playground);
          this.distance = playgroundLoc.getDistance(currentSearch);
        }
      }

      // If there are schedules, check if it is open
      if (this.playground.schedules) {
        const admin = this.playground.admin ? this.playground.admin.id : null;
        const listSchedules = parser(this.playground.schedules, this.getCurrentDate);
        const schedules = new Schedules(listSchedules, this.getCurrentDate, admin);
        this.todaySchedules = schedules.getPreview(1);
      }

      // List the playground facilities
      this.presentsFacilities = [];
      this.facilities.forEach((facility) => {
        if (this.playground.facilities[facility.id]) {
          this.presentsFacilities.push(facility);
        }
      });

      // Builds the URL of the images
      this.playgroundPhoto = this.playground.pictures[0] ?? null;
    },
  },
};
